import * as THREE from 'three';
import { useMemo, useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import vertexShader from '../src/shaders/Skybox/skyboxvertex.glsl';  // Update with your vertex shader path
import fragmentShader from '../src/shaders/Skybox/skyboxfragment.glsl';  // Update with your updated fragment shader path

export default function Skybox({ yes, ...props }) {
    const matRef = useRef();


    const uniforms = useMemo(() => {
        return {
            topColor: { value: new THREE.Color(0x0077ff) },  // Default top color
            bottomColor: { value: new THREE.Color(0xffffff) },  // Default bottom color
            exponent: { value: 0.5 }  // Default exponent
        };
    }, []);

    useFrame(() => {
        if (yes === true) {
            uniforms.topColor.value = new THREE.Color(0x1679AB);
            uniforms.bottomColor.value = new THREE.Color(0x77B0AA);
        } else {
            uniforms.topColor.value = new THREE.Color(0x3ABEF9);
            uniforms.bottomColor.value = new THREE.Color(0xffffff);
        }
    }, [yes]);

    return (
        <mesh position={[0, 0, 0]}>
            <sphereGeometry args={[1500, 32, 15]} />
            <shaderMaterial
                ref={matRef}
                vertexShader={vertexShader}
                fragmentShader={fragmentShader}
                uniforms={uniforms}
                side={THREE.BackSide}  // Ensure the material is applied to the back side of the sphere
            />
        </mesh>
    );
}
